import { render, staticRenderFns } from "./FundingRate.vue?vue&type=template&id=25939804&scoped=true&"
import script from "./FundingRate.vue?vue&type=script&lang=js&"
export * from "./FundingRate.vue?vue&type=script&lang=js&"
import style0 from "./FundingRate.vue?vue&type=style&index=0&id=25939804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25939804",
  null
  
)

export default component.exports